<template>
  <div class="cx-dropdown" 
    :class="{
      '-arrow': arrow
    }"
    ref="dropdown"
    @click="(e) =>click && handleClick(e)"
    @mouseenter="hover && handleMouseenter()"
    @mouseleave="hover && handleMouseLeave()"
    @mouseup="handleMouseup"
    @mousedown="handleMousedown"
    @focus="click && handleFocus()"
    @blur="(e) => click && handleBlur(e)"
    @keydown.esc="handleEsc"
  >
    <a role="button" class="cx-dropdown__trigger" ref="trigger" tabindex="0" 
      aria-haspopup="true" :aria-expanded="this.showContent ? 'true' : 'false'" 
      @keydown.enter="handleEnter">
      <slot :active="showContent"></slot>
    </a>
    <transition :name="transition">
      <div class="cx-dropdown__content m-dropdown__content" v-show="showContent">
        <slot name="content" ></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

/* eslint-disable */
export default {
  name: 'cx-dropdown',
  props: {
    trigger: {
      type: String,
      default: 'hover',
    },  
    keepDropdownAfterClick: {
      type: Boolean,
      defualt: false,
    },
    keepDropdownAfterBlur: {
      type: Boolean,
      defualt: false,
    },
    transition: {
      type: String,
      default: '',
    },
    arrow: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      mouseDownOnTrigger: true,
      showContent: false,
      cancelBlur: false,
      justFocus: false,
      hoverToShow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
    }),
    triggers() {
      return this.trigger.split(',').map(s => s.trim().toLowerCase())
    },
    hover() {
      return this.triggers.includes('hover');
    },
    click() {
      return this.trigger.includes('click');
    }
  },
  methods: {
    handleEnter() {
      this.showContent = !this.showContent;
      this.cancelBlur = false;
      this.justFocus = false;
    },
    handleEsc() {
      this.showContent = false;
      this.cancelBlur = false;
      this.justFocus = false;
    },
    _triggerInclude(e) {
      let path = this.getDOMPath(e.target);
      if (path) {
        return path.includes(this.$refs.trigger);
      }

      let pe = e.target;
      while (pe != this.trigger && pe.parentNode) {
        pe = pe.parentNode;
      }

      return pe == this.$refs.trigger;
    },
    handleClick(e) {
      const clickOnTrigger = this._triggerInclude(e); 
      if (this.keepDropdownAfterClick && !clickOnTrigger) return;

      if (this.justFocus) {
        this.justFocus = false;
        
        return;
      }

      if (!clickOnTrigger) {
        this.showContent = false;

        return;
      }

      this.showContent = !this.showContent;
      return;

      this.showContent = (!this.isMobile && this.showContent)
        ? true
        : !this.showContent 
    },      
    handleMouseenter() {
      this.showContent = true;
      this.hoverToShow = true;
      setTimeout(() => this.hoverToShow = false, 0);
    },
    handleMouseLeave() {
      this.showContent = false;
    },
    handleMouseup(e) {
      this.mouseDownOnTrigger = false;
    },
    handleMousedown(e) {
      if (this.hoverToShow) {
        this.hoverToShow = false;
        this.showContent = !this.showContent;
      }
      const clickOnTrigger = this._triggerInclude(e);
      this.mouseDownOnTrigger = clickOnTrigger;
      if (this.keepDropdownAfterClick) {
        this.cancelBlur = !clickOnTrigger && e.target.tagName == 'A';
      }
    },
    handleFocus() {
      this.showContent = true;
      this.justFocus = this.mouseDownOnTrigger && !this.justFocus;
    },
    handleBlur(e) {
      if (this.cancelBlur) {
        this.justFocus = true;
        this.cancelBlur = false;
        // this.$refs.dropdown.focus();
      } else if (this.showContent && !this.keepDropdownAfterBlur) {
        this.showContent = false;
      }
    }
  }
};
</script>

<style lang="scss">
.cv-slidedown-enter-active, .cv-slidedown-leave-active{
  transition: all .1s ease-in-out;
  transform-origin: center top;
  will-change: transform;
  transition-delay: .2s;
}

.cv-slidedown-enter, .cv-slidedown-leave-to {
  opacity: 0;
  transform: scaleY(0);
}

.cv-slidedown-enter-to, .cv-slidedown-leave {
  opacity: 1;
  transform: scaleY(1);
}

.cx-dropdown__content {
  width: 100%;
  right: 0;
}

.cx-dropdown.-arrow {
  .cx-dropdown__content {
    overflow: visible;
    max-height: inherit !important;
    left: auto; 
    @media (min-width: $breakpoint-md) {
      right: -15px;
    }
    &::after {
      border: 7px solid transparent;
      border-bottom-color: white;
      border-top: 0;
      content: "";
      position: absolute;
      top: -7px;
      right: 10px; 
      filter: drop-shadow(0 -1px 0 rgba(162, 162, 162, .3)) drop-shadow(0 2px 12px rgba(0, 0, 0, .1));
    }
  }
}
</style>